import { PortalThemeColors } from '@core/theme/theme.interfaces';
import { Colors, darkenColor, lightenColor, Theme, themeToennies } from '@iq-angular-libs/portal';

/**
 * Extends the Tönnies theme with relavant colors for the portal.
 */
const themeColors: PortalThemeColors = {
  ...themeToennies.themeColors,
  segmentPieChartBackground: Colors.gray400,
  befundTypColor1: Colors.denim,
  befundTypColor2: Colors.pictonBlue,
  befundTypColor3: Colors.charlotte,
  maskenvergleichGrundmaskeLineColor: Colors.gray550,
  maskenbetrachtungBalkenNeutralColor: Colors.gray550,
  maskenbetrachtungDiagrammDarkGruen: darkenColor(lightenColor(Colors.toenniesGreen, 15), 9),
  tageszunahmeTachoGradientStartColor: lightenColor(Colors.toenniesGreen, 45),
  tageszunahmeTachoGradientEndColor: lightenColor(Colors.toenniesGreen, 10)
};

/**
 * The new Tönnies theme extended with relevant colors.
 */
export const portalThemeToennies = new Theme<PortalThemeColors>(
  themeToennies.name,
  'THEME.STANDARD',
  themeToennies.class,
  themeColors
);
